<template>
  <div style="max-width:500px;height:200px;line-height: 200px;">
    <p v-if="type==='noRegistered'" class="is-centered">{{ $t("admin.NoParticipantToShow") }}</p>
    <p v-if="type==='noFinished'" class="is-centered">{{ $t("admin.NoParticipantFinished") }}</p>
    <p v-if="type==='noSelected' && listFiltered" class="is-centered">{{ $t("admin.NoParticipantSelected") }}</p>
    <p v-if="type==='noSelected' && !listFiltered" class="is-centered">{{ $t("admin.NoParticipantFinished") }}</p>
    <p v-if="type==='noColors' && !listFiltered" class="is-centered">{{ $t("admin.NoParticipantColors") }}</p>
  </div>
</template>

<script>
export default {
  props:['type', 'listFiltered']
};
</script>
